import React, { useState } from "react";
import { fdAttendeeTileLabel } from "../copy.js";

export default function AttendeeTile({ person, selected, onToggle, atMaxPicks, readOnly = false }) {
  const [imgFailed, setImgFailed] = useState(false);
  const disabled = readOnly || (atMaxPicks && !selected);
  const initial = person.name?.trim()?.slice(0, 1) || "?";
  const label = readOnly
    ? person.name
    : fdAttendeeTileLabel(person.name, { selected, atMaxPicks });

  const shellClass = `min-w-0 text-left rounded-md2 p-2 border transition-colors min-h-[44px] ${
    readOnly
      ? "border-black/[0.06] bg-white cursor-default"
      : selected
        ? "border-plum bg-purply/15 ring-1 ring-plum/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-orchid/45 focus-visible:outline-offset-2"
        : "border-black/[0.08] bg-white hover:bg-cream focus-visible:outline focus-visible:outline-2 focus-visible:outline-orchid/45 focus-visible:outline-offset-2"
  } disabled:opacity-45 disabled:cursor-not-allowed`;

  const inner = (
    <>
      <div
        className="w-full aspect-square rounded-full bg-pinky/40 overflow-hidden grid place-items-center font-ui font-semibold text-[18px] mb-2"
        aria-hidden
      >
        {person.thumbnail_url && !imgFailed ? (
          <img
            src={person.thumbnail_url}
            alt=""
            className="w-full h-full object-cover"
            onError={() => setImgFailed(true)}
          />
        ) : (
          <span>{initial}</span>
        )}
      </div>
      <p className="font-ui font-semibold text-[13px] text-center truncate text-ink" title={person.name}>
        {person.name}
      </p>
    </>
  );

  if (readOnly) {
    return (
      <div className={shellClass} aria-label={label}>
        {inner}
      </div>
    );
  }

  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={selected}
      aria-label={label}
      onClick={() => onToggle(person.dancer_id)}
      className={shellClass}
    >
      {inner}
    </button>
  );
}
